// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // apiURL: 'http://localhost:3333',
    // projectURL: 'http://localhost:4200',
    apiURL: 'https://api-protocolo.gerin.us',
    projectURL: 'https://protocolo.gerin.us',
    fiscoURL: '',
    govBR: {
        url: 'https://sso.staging.acesso.gov.br',
        clientID: 'protocolo.gerin.us',
        returnURL: 'https://protocolo.gerin.us/principal',
        secret: '',
        logoutUrl: 'https://sso.staging.acesso.gov.br/logout?post_logout_redirect_uri=https://protocolo.gerin.us/principal?logout=true',
        apiUrl: "https://api.staging.acesso.gov.br",
        signUrl: 'https://cas.staging.iti.br/oauth2.0',
        returnSignUrl: 'https://protocolo.gerin.us/requests/new',
        secretSign: '',
        signClientID: ''
    },
    secretKey: '',
    cryptoSecret: '',
    pdfWorker: ""
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
